export default __webpack_public_path__ + "static/media/qb_cancel_icon.7f30ee42.svg";